<template>
    <div>
        <Multiselect
            v-model="selected"
            :options="options"
            :multiple="true"
            :close-on-select="false"
            track-by="id"
            label="label"
            :placeholder="placeholder"
            select-label=""
            selected-label=""
            deselect-label=""
        />
        <input
            v-for="opt in selected"
            :key="opt.id"
            type="hidden"
            :name="name"
            :value="opt.id"
        />
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    components: { Multiselect },
    props: {
        name: { type: String, required: true },
        options: { type: Array, required: true },
        initial: { type: Array, default: () => [] },
        placeholder: { type: String, default: "Seleccione..." },
    },
    data() {
        const initialKeys = this.initial.map(String);
        return {
            selected: this.options.filter((o) =>
                initialKeys.includes(String(o.id))
            ),
        };
    },
};
</script>
